var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#6B7280",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7498 3.99977C21.7497 3.03336 20.9662 2.25 19.9998 2.25H3.99966C3.03316 2.25 2.24966 3.0335 2.24966 4V5.58579C2.24966 6.04992 2.43403 6.49503 2.76222 6.82322L9.17644 13.2374C9.22332 13.2843 9.24966 13.3479 9.24966 13.4142L9.24966 19.2192C9.24966 20.0222 9.79618 20.7222 10.5752 20.917L12.5752 21.417C13.6797 21.6931 14.7497 20.8577 14.7497 19.7192L14.7497 13.4142C14.7497 13.3479 14.776 13.2843 14.8229 13.2374L21.2374 6.8233C21.5657 6.49505 21.7501 6.04982 21.75 5.5856L21.7498 3.99977ZM19.9998 3.75C20.1379 3.75 20.2498 3.86191 20.2498 3.99997L20.25 5.58579C20.25 5.65211 20.2237 5.71571 20.1768 5.76261L13.7623 12.1768C13.4341 12.505 13.2497 12.9501 13.2497 13.4142L13.2497 19.7192C13.2497 19.8819 13.0968 20.0012 12.939 19.9618L10.939 19.4618C10.8277 19.4339 10.7497 19.3339 10.7497 19.2192L10.7497 13.4142C10.7497 12.9501 10.5653 12.505 10.2371 12.1768L3.82288 5.76256C3.776 5.71568 3.74966 5.65209 3.74966 5.58579V4C3.74966 3.86193 3.86159 3.75 3.99966 3.75H19.9998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.b576b5c23f088827cad01e37012d3fe9.svg";
export { ForwardRef as ReactComponent };